import Clickable from 'components/Common/Clickable'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import ModalContext from 'contexts/ModalContext'
import { rem } from 'polished'
import React, { useContext, useMemo } from 'react'
import styled from 'styled-components'
import ExperienceCancellationPolicyModal from './ExperienceCancellationPolicyModal'
import useTrackExperienceOfferEvent from 'contexts/support/useTrackExperienceOfferEvent'

const IconText = styled(Clickable)`
  display: flex;
  align-items: center;

  > * + * {
    margin-left: ${rem(8)};
  }
`

interface Props {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  cancellationInfo?: App.ExperienceItemCancellationInfo;
  className?: string;
  date?: string;
  onSupportEmailClick?: () => void
  onSupportNumberClick?: () => void
  textSize?: 'small' | 'medium'
}

function ExperienceCancellationText(props: Props) {
  const { cancellationInfo, onClick, className, date, onSupportEmailClick, onSupportNumberClick, textSize = 'medium' } = props
  const trackEvent = useTrackExperienceOfferEvent()

  const showModal = useContext(ModalContext)
  const hasFullRefund = useMemo(() => cancellationInfo?.refundPolicies?.some(policy => policy.value === 100 && policy.type === 'PERCENTAGE'), [cancellationInfo])
  const onTextClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    e.preventDefault()
    showModal(<ExperienceCancellationPolicyModal
      cancellationInfo={cancellationInfo}
      date={date}
      onSupportEmailClick={onSupportEmailClick}
      onSupportNumberClick={onSupportNumberClick}
    />)
    onClick?.(e)
    trackEvent('CANCELLATION_POLICY_CLICKED')
  }

  if (!cancellationInfo?.refundPolicies?.length) {
    return null
  }

  return (
    <IconText onClick={onTextClick} className={className}>
      <BodyText colour="highlight-secondary" variant={textSize} weight="bold">
        {hasFullRefund && 'Free cancellation'}
        {!hasFullRefund && 'Flexible cancellation'}
      </BodyText>
      <LineInfoCircleIcon colour="neutral-one" size={textSize === 'small' ? 'XS' : 'S'} />
    </IconText>
  )
}

export default ExperienceCancellationText
